import { render, staticRenderFns } from "./IndustryExperience.vue?vue&type=template&id=68976515&scoped=true"
import script from "./IndustryExperience.vue?vue&type=script&lang=js"
export * from "./IndustryExperience.vue?vue&type=script&lang=js"
import style0 from "./IndustryExperience.vue?vue&type=style&index=0&id=68976515&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68976515",
  null
  
)

export default component.exports